import PersonSearchOutlinedIcon from "@mui/icons-material/PersonSearchOutlined";
import i18n from "../../../../utils/i18n.js";
import classes from "./accountingUpsellCard.module.scss";

const AccountingUpsellCard = ({ checked, onChange }) => (
  <div className={classes.root}>
    <span className={classes.badge}>{i18n.t("searchflow.accountingupsellbadge")}</span>
    <div className={classes.header}>
      <div className={classes.iconCircle} aria-hidden="true">
        <PersonSearchOutlinedIcon className={classes.icon} />
      </div>
      <button
        type="button"
        className={`${classes.switch} ${checked ? classes.switchOn : ""}`}
        role="switch"
        aria-checked={checked}
        onClick={() => onChange(!checked)}
      >
        <span className={classes.switchThumb} aria-hidden="true" />
      </button>
    </div>
    <p className={classes.title}>{i18n.t("searchflow.accountingupselltitle")}</p>
    <p className={classes.description}>{i18n.t("searchflow.accountingupselldesc")}</p>
  </div>
);

export default AccountingUpsellCard;
